import axios from 'axios';
import Cookies from 'universal-cookie';
import { IS_LOCALHOST, API_ROOT, ORDER_PORT, config } from '../../configs/environments';
import CONSTANTS from '../../configs/constants';

const cookies = new Cookies();

const attachCookie = () => {
  if (!IS_LOCALHOST) {
    config.headers.sso_token_wimo = cookies.get(CONSTANTS.SSO_COOKIE_NAME);
  }
};

const API = () => (
  {
    getOrders: () => {
      attachCookie();
      return axios.get(IS_LOCALHOST ? `${API_ROOT}/orders.json` : `${API_ROOT}:${ORDER_PORT}/api/orders?numResults=${CONSTANTS.MAX_RESULTS}`, config);
    },
    getOrderDetails: (transactionId) => {
      attachCookie();
      return axios.get(IS_LOCALHOST ? `${API_ROOT}/orderDetails/${transactionId}.json` : `${API_ROOT}:${ORDER_PORT}/api/orders/${transactionId}`, config);
    },
  }
);


export default API(axios);



// WEBPACK FOOTER //
// src/services/orderService/api.js